import { Observable } from 'rxjs/Observable';
import { Notification } from 'rxjs/Notification';
import { Action } from '@ngrx/store';
import { ErrorReporter } from './error_reporter';

export interface EffectNotification {
  effect: Observable<any> | (() => Observable<any>);
  propertyName: string;
  sourceName: string;
  sourceInstance: any;
  notification: Notification<Action | null | undefined>;
}
/**
 * @param {?} output
 * @param {?} reporter
 * @return {?}
 */
export function verifyOutput(
  output: EffectNotification,
  reporter: ErrorReporter
) {
  reportErrorThrown(output, reporter);
  reportInvalidActions(output, reporter);
}
/**
 * @param {?} output
 * @param {?} reporter
 * @return {?}
 */
function reportErrorThrown(
  output: EffectNotification,
  reporter: ErrorReporter
) {
  if (output.notification.kind === 'E') {
    const /** @type {?} */ errorReason = `Effect ${getEffectName(output)} threw an error`;

    reporter.report(errorReason, {
      Source: output.sourceInstance,
      Effect: output.effect,
      Error: output.notification.error,
      Notification: output.notification,
    });
  }
}
/**
 * @param {?} output
 * @param {?} reporter
 * @return {?}
 */
function reportInvalidActions(
  output: EffectNotification,
  reporter: ErrorReporter
) {
  if (output.notification.kind === 'N') {
    const /** @type {?} */ action = output.notification.value;
    const /** @type {?} */ isInvalidAction = !isAction(action);

    if (isInvalidAction) {
      const /** @type {?} */ errorReason = `Effect ${getEffectName(
        output
      )} dispatched an invalid action`;

      reporter.report(errorReason, {
        Source: output.sourceInstance,
        Effect: output.effect,
        Dispatched: action,
        Notification: output.notification,
      });
    }
  }
}
/**
 * @param {?} action
 * @return {?}
 */
function isAction(action: any): action is Action {
  return action && action.type && typeof action.type === 'string';
}
/**
 * @param {?} __0
 * @return {?}
 */
function getEffectName({
  propertyName,
  sourceInstance,
  sourceName,
}: EffectNotification) {
  const /** @type {?} */ isMethod = typeof sourceInstance[propertyName] === 'function';

  return `"${sourceName}.${propertyName}${isMethod ? '()' : ''}"`;
}



// WEBPACK FOOTER //
// ../../../modules/effects/src/effect_notification.ts